"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LabelList = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Label = require("./Label");
var _templateObject;
var StyledLabelList = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  flex-wrap: wrap;\n  margin-left: -4px;\n"])));
var LabelList = exports.LabelList = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var labels = _ref.labels,
    max = _ref.max;
  if (!labels || labels.length === 0) return null;
  var displayedLabels = max ? labels.slice(0, max) : labels;
  var labelNodes = displayedLabels.map(function (label) {
    return /*#__PURE__*/_react["default"].createElement(_Label.Label, {
      key: label._id,
      color: label.color,
      text: label.text,
      onClick: label.onClick
    });
  });
  return /*#__PURE__*/_react["default"].createElement(StyledLabelList, null, labelNodes);
});